import { TextUtils } from '../../../resources/text.utils';
import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { FormControl, NgControl } from '@angular/forms';
import * as VMasker from 'vanilla-masker';

@Directive({
    selector: '[DocMask]',
})
export class DocMaskDirective implements OnInit {
    @Input() public maskOption;
    @Input() public padValue: number|string;
    @Input() public padLength: number;
    @Input() public padPosition: 'start'|'end';
    @Input('DocMask') public formControl: FormControl;

    public nativeElement: HTMLInputElement;

    constructor(
        public element: ElementRef,
        private control: NgControl,
        private textUtils: TextUtils,
    ) {
        this.nativeElement = this.element.nativeElement;
    }

    public ngOnInit() {
        setTimeout(() => {
            if (this.control.control?.value) {
                const formattedValue = this.formatValue(this.control.control.value);
                this.control.control.setValue(formattedValue, { emitEvent: false });
            }
        });
    }

    @HostListener('input', ['$event'])
    public onEvent($event) {
        this.control.control.setValue(this.formatValue(this.nativeElement.value));
    }

    @HostListener('focusout', ['$event'])
    public onFocusout($event) {
        if (this.padValue) {
            this.control.control.setValue(this.padFormValue(this.nativeElement.value));
        }
    }

    private formatValue(value: string) {

        switch (this.maskOption) {
            case 'cpf':
                return VMasker.toPattern( value, '999.999.999-99' );

            case 'onlyNumbers':
                return VMasker.toNumber( value ); // não existe padrão de RG, cada estado utiliza uma máscara diferente

            case 'cep':
                return VMasker.toPattern( value, '99.999-999' );

            case 'cnpj':
                return VMasker.toPattern( value, '99.999.999/9999-99' );

            case 'cnpj-alfa':
                return VMasker.toPattern( value.toUpperCase(), 'SS.SSS.SSS/SSSS-99' );

            case 'cpf-cnpj':
                return value.length <= 11
                    ? VMasker.toPattern( value, '999.999.999-99?9' )
                    : VMasker.toPattern( value.toUpperCase(), 'SS.SSS.SSS/SSSS-99' );
        }

    }

    /**
     * Formata o valor do formulário inserindo um caracter definido no inicio ou no final da string
     * @param value - valor do formulário
     */
    private padFormValue(value: string): string {
        if (this.padValue && this.padLength) {
            switch (this.padPosition) {
                case 'start': {
                    return this.textUtils.padStart(this.nativeElement.value, this.padValue.toString(), this.padLength);
                }
                case 'end': {
                    return this.textUtils.padEnd(this.nativeElement.value, this.padLength, this.padValue.toString());
                }
            }
        }

        return value;
    }
}
